import AuthRoute from '../../components/layouts/AuthRoute/AuthRoute';
import { Column } from '@lightningjs/ui-components';
import VODInfo from '../Home/components/VODInfo';
import { Colors, Router, Storage, Utils } from '@lightningjs/sdk';
import Lightning from '@lightningjs/sdk/src/Lightning';
import PaidTitleModal from '../Home/components/UpgradeModal';
export default class New extends AuthRoute {
  static _template() {
    return {
      ...super._template(),
      PaidTitleModal: {
        zIndex: 200,
        w: 1920,
        h: 1080,
        rect: true,
        color: Colors('#000000').get(),
        type: PaidTitleModal,
        visible: false,
      },
      LogoIcon: {
        w: 606,
        h: 274,
        Shadow: {
          y: 806,
          x: 1314,
          rect: true,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo-shadow.png'), 606, 274),
          zIndex: 99,
        },
        Logo: {
          y: 978,
          x: 1555,
          texture: Lightning.Tools.getSvgTexture(Utils.asset('images/logo.png'), 341, 53),
          zIndex: 100,
        },
      },
      Content: {
        x: 200,
        y: 0,
        h: 500,
        w: 1720,
        type: VODInfo,
        visible: false,
      },
      Wrapper: {
        x: 150,
        y: 480,
        h: 600,
        w: 1770,
        clipping: true,
        Column: {
          collision: true,
          x: 51,
          y: 40,
          type: Column,
        },
      },
      ResultText: {
        visible: false,
        y: 460,
        x: 300,
        text: {
          text: 'Sorry, there are no new movies available at the moment. Please check back later!',
          fontSize: 36,
          lineHeight: 40,
          textColor: Colors('#fafafa').get(),
        },
      },
    };
  }

  get id() {
    return 'NewPage';
  }

  set data(val) {
    return (this._data = val);
  }

  _enable() {
    this._setState('Column');
    if (this._data.seriesArray.length > 0 || this._data.moviesArray.length > 0) {
      this.tag('Content').patch({ visible: true });
      this.tag('ResultText').visible = false;
    } else {
      this.tag('Content').patch({ visible: false });
      this.tag('ResultText').visible = true;
    }

    this.tag('Content.Info').patch({
      zIndex: 100,
    });
  }

  get _Column() {
    return this.tag('Wrapper.Column');
  }

  _handleLeft() {
    if (!Router.isNavigating()) {
      Router.focusWidget('sidebar');
    }
  }

  $hidePaidTitleModal() {
    this.tag('PaidTitleModal').visible = false;
    this._setState('Column');
  }

  $changeVODInfo({ title, description, category, duration, cover, rating, votes, contentRating }) {
    // Debounce funkcionalnost
    if (!this._debouncedChangeVODInfo) {
      this._debouncedChangeVODInfo = this._debounce(
        (title, description, category, duration, cover, rating, votes, contentRating) => {
          const ratingText = `${rating}/10`;
          const categoryText = category && category.length > 0 ? category.join(' • ') : '';
          const parts = duration.split(':').map((part) => parseInt(part));
          let seconds = 0;

          if (parts.length === 3) {
            // If time format is HH:MM:SS
            seconds = parts[0] * 3600 + parts[1] * 60 + parts[2];
          } else if (parts.length === 2) {
            // If time format is MM:SS
            seconds = parts[0] * 60 + parts[1];
          }

          // Modify the duration text
          let hours = parts.length === 3 ? parts[0].toString().padStart(2, '0') : '00';
          let minutes =
            parts[parts.length - 2] !== undefined
              ? parts[parts.length - 2].toString().padStart(2, '0')
              : '00';
          let secondsPart = parts[parts.length - 1].toString().padStart(2, '0');
          const durationText =
            seconds >= 3600
              ? `${hours}:${minutes}:${secondsPart} | `
              : `${minutes}:${secondsPart} | `;

          // Fade-in animacija za Title, Informations i Cover
          const contentInfo = this.tag('Content.Info');
          contentInfo.alpha = 0;
          const coverImage = this.tag('Content.Cover');
          coverImage.alpha = 0;
          // Postavimo alpha na 0 pre patchovanja
          // contentInfo.setSmooth('alpha', 0, { duration: 0 });
          // coverImage.setSmooth('alpha', 0, { duration: 0 });

          // Patch-uj nove informacije
          contentInfo.patch({
            Title: { text: { text: title } },
            Informations: {
              DurationAndIcon: {
                Svg: {
                  x: seconds > 3600 ? 130 : 90,
                  texture: lng.Tools.getSvgTexture(
                    Utils.asset('images/movie-info-icons/star.svg'),
                    20,
                    20
                  ),
                },
                text: { text: durationText },
              },
              Rating: {
                x: seconds > 3600 ? 165 : 125,
                text: { text: `IMDB ${ratingText}` },
              },
              Votes: {
                x: seconds > 3600 ? 315 : 275,
                text: { text: `(${votes})` },
              },
              ContentRating: {
                x: seconds > 3600 ? 375 : 330,
                text: { text: `| (${contentRating})` },
              },
            },
            Category: { text: { text: categoryText } },
            Description: { text: { text: description } },
          });

          // Patch-uj cover sliku
          coverImage.patch({
            texture: { src: cover },
          });

          // Fade-in animacija
          contentInfo.setSmooth('alpha', 1, { duration: 0.5 });
          coverImage.setSmooth('alpha', 1, { duration: 0.5 });
        },
        500
      ); // Debounce delay od 300ms
    }

    // Pozivamo debounced funkciju
    this._debouncedChangeVODInfo(
      title,
      description,
      category,
      duration,
      cover,
      rating,
      votes,
      contentRating
    );
  }

  // Debounce funkcija
  _debounce(func, delay) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }

  $unselectCurrentIndex() {
    let currentIndex = this._Column.selectedIndex;
    let rowIndex = this._Column.items[currentIndex].selectedIndex;
    this._Column.items[currentIndex].items[rowIndex]._unfocus();
  }

  $setFocus({ rowIndex, index }) {
    let currentIndex = this._Column.selectedIndex;
    this._Column.scrollTo(rowIndex, 200);
    this._Column.items[rowIndex].scrollTo(index, 10);
  }

  $scroll(event) {
    this._handleScroll(event);
  }

  _handleScroll(event) {
    let currentIndex = this._Column.selectedIndex;
    let nextIndex = currentIndex + 1;
    let previousIndex = currentIndex - 1;
    if (event.deltaY > 0) {
      this._Column.scrollTo(nextIndex, 50);
    } else if (event.deltaY < 0) {
      this._Column.scrollTo(previousIndex, 50);
    }
  }

  $handleEnter() {
    let fp = this.application.focusPath;
    let isProtected = (fp && fp.length > 0 && fp[fp.length - 1])._isProtected;
    let activeTile = fp[fp.length - 1].data || {};
    Storage.set('video', { id: activeTile.id, watchList: 0 });
    switch (activeTile.kind) {
      case 'movie':
        if (isProtected) {
          this.tag('PaidTitleModal').visible = true;
          this._setState('PaidTitleModal');
        } else {
          Storage.set('video', { id: activeTile.id, watchList: 0 });
          Router.navigate(`movie/${activeTile.id}`);
        }

        break;
      case 'subseries':
        this.navigate(`series/${activeTile.id}`);
        break;
      case 'collection':
        this.navigate(`categories/${activeTile.id}`);
    }
  }

  static _states() {
    return [
      class PaidTitleModal extends this {
        _getFocused() {
          return this.tag('PaidTitleModal');
        }
      },
      class Column extends this {
        _getFocused() {
          return this._Column;
        }
      },
    ];
  }
}
